import React from 'react';
import styled from 'styled-components';

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
`;

export default FlexRow;
